//Import all needed framework stuff
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'mobx-react';

//Import App Component
import App from './app/App';

//Import Stores
import RootStore from './app/stores/index';

//Import Master Styles (main SASS file, components include their own as needed)
import './theme/index.scss';

//Import Service Workers
import * as serviceWorker from './serviceWorker';

//Supply any Store Classes Here
const rootStore = new RootStore();

//Head Scripts
window.dataLayer = window.dataLayer || [];
window.digitalData = window.digitalData || [];
// window.onload = function() {
//   var orientation = 'portrait';
//   const digitalData = {};
//
//   window.digitalData = digitalData;
// }

//DTM Becuase They do this wrong.
const dtmHead = document.createElement('script');

if(process.env.NODE_ENV === 'production'){
  dtmHead.setAttribute('src','//assets.adobedtm.com/launch-ENbf49cbaca6684d9a8703b3308a3c1e07.min.js');
  document.head.appendChild(dtmHead);
}else{
  dtmHead.setAttribute('src','//assets.adobedtm.com/launch-EN85ca938765194fb3bd4777900962e5be-development.min.js');
  document.head.appendChild(dtmHead);
}

const dtmSat = document.createElement("script");
const inlineScript = document.createTextNode(`window.onload = function() {
  _satellite.pageBottom();
};`);
dtmSat.type = "text/javascript";
dtmSat.appendChild(inlineScript);
document.body.appendChild(dtmSat);


ReactDOM.render(<Provider RootStore={rootStore}><App/></Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
